module.exports = ".modal-backdrop-custom {\r\n    top: 5% !important;\r\n    right: 7.5% !important;\r\n    bottom: 10% !important;\r\n    width: 90% !important;\r\n}\r\n\r\n.modal-backdrop-custom-child {\r\n    left: 2.5% !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/communication/newroom/modal-communication-newroom.component.css
// module id = ./src/app/app_manager/modal/communication/newroom/modal-communication-newroom.component.css
// module chunks = main